<template>
  <div class="LaptopSpec">
    <Set :label="label">
      <LaptopScore
        slot="icon"
        :class="scoreClass"
        :label="label"
        :score="score" />
      <div class="value">
        {{ value }}
      </div>
    </Set>
  </div>
</template>

<script>
import LaptopScore from './LaptopScore'

export default {
  components: {
    LaptopScore,
  },
  props: {
    label: String,
    score: [Number, String],
    scoreClass: String,
    value: [Number, String],
  },
}
</script>

<style lang="scss">
.LaptopSpec {
  .LaptopScore {
    margin-right: 0.5rem;
  }
}
</style>
